import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "HelpCenterArticleWidget" */ './HelpCenterArticleWidget'),
  modules: ['./HelpCenterArticleWidget'],
  loading: () => <div />
});

export default LoadableWidget;
